import { useParams } from 'react-router-dom'
import EmailRequestForm from '../components/EmailRequestForm'

export default function Item(){
  const { slug = '' } = useParams()
  // In a real app, fetch item metadata by slug
  const title = slug.split('/').pop()
  return (
    <div className="mx-auto max-w-3xl px-4 py-10">
      <h1 className="text-2xl font-semibold mb-2">{title}</h1>
      <p className="text-gray-600 mb-6">Item details would go here.</p>
      <EmailRequestForm itemId={slug} />
    </div>
  )
}